import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HandledHttpResponse, httpRunner, PaginatedResult } from '@uzenith360/http-utils';
import { getCurrencySymbolByCurrencyCode } from '@pixomaticc/ngx-ui';
import { Observable, lastValueFrom } from 'rxjs';
import Utils from '@uzenith360/utils';
import { environment } from 'src/environments/environment';
import ReferralsDataInterface, { LeaderboardData } from './referrals-data.interface';

@Injectable({
  providedIn: 'root'
})
export class ReferralEarningsService {

  constructor(private http: HttpClient) { }

  fetchPhotographerReferrals(filter: 'ALL' | 'SUBSCRIBED' | 'NOT_SUBSCRIBED' = 'ALL', page: number = 1, limit: number = 10)
    : Observable<HandledHttpResponse<PaginatedResult<ReferralsDataInterface>>> {
    return httpRunner(this.http.get(`${environment.usersBaseUrl}/photographers/referrals`, { params: { filter, page, limit } }));
  }

  requestReferralClaims(ids: string[])
    : Observable<HandledHttpResponse<boolean>> {
    return httpRunner(this.http.post(`${environment.usersBaseUrl}/photographers/request-referral-claims`, { ids }));
  }

  fetchLeaderboard(): Observable<HandledHttpResponse<LeaderboardData>> {
    return httpRunner(this.http.get(`${environment.usersBaseUrl}/referrals/leaderboard`));
  }

  // Returns the formatted STUDIO × YEARLY × 5 monthly earning potential.
  // Used by both the referral intro dialog and anywhere else that needs this figure.
  async getEarningsPotential(): Promise<string> {
    try {
      const response = await lastValueFrom(this.fetchPhotographerReferrals('ALL', 1, 1));
      if (response.statusCode === 200 && response.data) {
        const paginatedData = response.data as PaginatedResult<ReferralsDataInterface>;
        const studioYearly = paginatedData.data?.referralAmounts?.find(
          r => r.billing === 'STUDIO' && r.cycle === 'YEARLY'
        );
        if (studioYearly) {
          return Utils.formatMoney(
            studioYearly.amount * 5,
            getCurrencySymbolByCurrencyCode(paginatedData.data.currency),
          );
        }
      }
    } catch {}
    return '';
  }
}
